import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
import moment from 'moment'
export default {
  name: 'client',
  components: {
    Pagination,
  //  Paginate,
    Loader
  },
  data: function() {
    return {
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      pageLimit:10,

      //currentPage: 0,
      modalShow: false,
      editInventorymodal: false,
      addInventorymodal: false,
      addmodalshow: false,
      status: '',
      Inventoryaction: '',
      listInventoryData: [],
      listClientData: [],
      ClientErr: '',
      // pageno: 0,
      // pagecount: 0,
      showSelectClient: false,
      isLoading: false,
      is_Loading: false,
      resultCount: 0,
      client: '',
      inventoryname: '',
      searchinventoryname: '',
      clientname: '',
      editinventoryname: '',
      addinventoryname: '',
      status: '',
      changestatus: '',
      formattedDate:'',
      showresult:false,
      searchFlag: false
    }
  },
  created: function() {},
  // when a page loads,mounted() will be call
  mounted() {
    var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
    this.pageno = 0
    // this.getClientList()
    // this.getInventoryData()
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;

    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
  },
  methods: {
    //open new form(popup)
    addNewClient() {
      this.Inventoryaction = 'add'
      this.addInventorymodal = true
      this.clientname = '';
      this.addinventoryname = '';

      //to clear error messages(validation messages)
      this.$validator.reset();
      this.errors.clear();
    },
    // to open add modal
    addmodalShow() {
      this.Statusaction = 'add'
      this.addmodalShow = true
    },
    //to close active/inactive modal
    closeaddmodalShow() {
      this.addmodalShow = false
    },
    //to close new form
    closeaddInventorymodal() {
      this.addInventorymodal = false
    },
    //to close edit form
    closeEditInventoryModal() {
      this.addInventorymodal = false
    },
    //to reset search form



    //to get client list
    // getClientList() {
    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.listClientData = JSON.parse(plaintextclient);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageno = 0;

    //     this.input = ({
    //       warehouseid: this.warehouseid,
    //     });

    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr,
    //         }
    //       })
    //       .then(result => {
    //         this.listClientData = result.data.data;
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },
    getInventorySearch(){
      this.currentPage =1;
      this.getInventoryData();
      this.searchFlag = true;
    },
    //to get client list
    getInventoryData() {
      this.showresult=false
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
        this.ClientErr = this.$t('common.clientError');
        this.pageno = this.pageCount = 0;
        this.listInventoryData = [];
        return false;
      }

      this.input = ({
        offset: (this.currentPage - 1) * 10,
        limit: 10,
        inventoryname: this.searchinventoryname.trim(),
        clientid: localStorage.getItem("selectedClient"),
      })
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'GetInventoryList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listInventoryData = result.data.data
          this.isLoading = false;
          // let totalRows = result.data.count
          // this.resultCount = result.data.count
          // if (totalRows < 10) {
          //   this.pagecount = 1
          // } else {
          //   this.pagecount = Math.ceil(totalRows / 10)
          // }
          this.totalCount = result.data.count
          this.resultCount = result.data.count;
          if( this.resultCount==0){
            this.showresult=true
          }
          if (this.totalCount < 10) {
            this.totalPage = 1
          } else {
            this.totalPage = Math.ceil(this.totalCount / 10);
          }
        }, error => {
          console.error(error)
        })
    },
    // save form fields in mysql database
    saveInventory() {

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'saveInventoryData',
          'data': {
            'inventoryname': this.addinventoryname.trim(),
            'status': 1,
            'clientid': localStorage.getItem("selectedClient"),

          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.errorCode == 1) {
            this.is_Loading = false
            this.$alertify.success(response.data.msg)
            this.addInventorymodal = false;
            this.resetaddDeatilsForm();
            this.getInventoryData();

          } else if (response.data.errorCode == 0) {
            this.is_Loading = false
            this.$alertify.error(response.data.msg)
            this.resetaddDeatilsForm();

            this.addInventorymodal = true
            // this.getInventoryData();
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //to get target id in edit action
    getInventoryRowData(data) {
      this.Inventoryaction = 'edit';
      this.addInventorymodal = true;
      this.$validator.reset();
      this.errors.clear();
      this.id = data.id;
      this.editinventoryname = data.inventoryname;
      this.clientname = data.clientid;
      this.Cname =data.clientname;

    },
    getStatusRowData(data) {
      this.Statusaction = 'add'
      this.modalShow = true
      this.clientid = data.clientid
      this.status = data.status
      this.editinventoryname = data.inventoryname
      if (data.status == '0') {
        this.changestatus = 'Activate'
      } else {
        this.changestatus = 'De-Activate'
      }
    },
    //for active/inactive modal
    changeInventoryStatus() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'updateInventoryStatus',
          'data': {
            'clientid': localStorage.getItem("selectedClient"),
            'status': this.status,
            'inventoryname': this.editinventoryname
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.msg > 0) {
            this.$alertify.success("Inventory Status update Successfully")
            this.addInventorymodal = false
            this.getInventoryData();
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //update form fields
    editInventory() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({
        'inventoryname': this.editinventoryname,
        'id': this.id,
        'clientid': localStorage.getItem("selectedClient"),
      })
      this.is_Loading = true
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'UpdateInventoryData',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.errorCode == 1) {
            this.is_Loading = false
            this.$alertify.success(response.data.msg)
            this.addInventorymodal = false
            this.getInventoryData();
            this.reseteditDeatilsForm();
          } else if (response.data.errorCode == 0) {
            this.is_Loading = false
            this.$alertify.error(response.data.msg)
          }

        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //to get target id in active/inactive modal
    reseteditDeatilsForm() {
      this.clientname = '';
      this.editinventoryname = '';

    },
    resetForm() {
      this.searchinventoryname = '';
      // this.client = '';
      this.resultCount = 0;
      this.showresult=false
      this.listInventoryData = [];
      this.searchFlag = false;
      // this.getInventoryData();
    },
    resetaddDeatilsForm() {
      this.clientname = '';
      this.addinventoryname = '';

    },

    //change status of modal
    closeStatusInventoryModal() {
      this.modalShow = false
    },
    //to get pagination
    // getPaginationData(currentPage) {
    //   this.pageno = (currentPage - 1) * 10
    //   this.getInventoryData()
    // },
    onPageChange(page) {
      this.currentPage = page;
      this.getInventoryData()
    },
    //validate all form fields on onsubmit()
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          console.log('form is invalid', this.model)
          return false;
        } else {
          console.log('form is valid', this.model)
          // this.validateformat()
        }

      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/subinventorymaster/subinventorymaster.component.js